<template>
    <a
            :href="link"
            class="insight-card-featured u-reset"
            :class="rootClasses"
            :style="backgroundImage(image)">
        <div class="insight-card-featured--content u-reset">
            <h3 class="insight-card-featured--title u-reset">{{ title }}</h3>

            <div class="insight-card-featured--footer">
                <div class="insight-card-featured--footer-col">
                    <dyn-insight-authors :authors="authors" :and-separator="andSeparator" class="insight-card--authors"/>
                    <div class="insight-card-featured--info">
                        <div class="insight-card-featured--date">
                            <dyn-insight-date :date="postDate" :language="language"/>
                        </div>
                        <div class="insight-card-featured--readingtime" v-if="readingTime">
                            <dyn-insight-readingtime :value="readingTime"/>
                        </div>
                    </div>
                </div>

                <div class="insight-card-featured--icon u-reset" v-if="hasArrow">
                    <ui-icon symbol="arrow-right" size="large"/>
                </div>
            </div>
        </div>
    </a>
</template>

<script>
    import UiIcon from '@dreipol/vue-ui/src/components/icon/icon.vue';
    import { bemMixin } from '@dreipol/vue-ui/src/mixins';

    export default {
        components: {
            UiIcon,
        },
        mixins: [bemMixin('insight-card-featured')],
        props: {
            title: {
                type: String,
                required: true,
            },
            tags: {
                type: Array,
                default: () => [],
            },
            link: {
                type: String,
                required: true,
            },
            description: {
                type: String,
                default: '',
                required: false,
            },
            id: {
                type: Number,
                required: true,
            },
            image: {
                type: String,
                default: null,
            },
            postDate: {
                type: Number,
                default: null,
            },
            readingTime: {
                type: Number,
                default: null,
            },
            hasArrow: {
                type: Boolean,
                default: false,
            },
            language: {
                type: String,
                default: 'de',
            },
            authors: {
                type: Array,
                default: () => [],
            },
            andSeparator: {
                type: String,
                default: null,
            },
        },
        computed: {
            rootClasses() {
                return [
                    this.bemIf(this.hasArrow, 'has-arrow', 'base'),
                ];
            },
        },
        methods: {
            generateTagLink(tag) {
                return `${ window.location.pathname }?query=${ encodeURIComponent(tag.title) }`;
            },
            backgroundImage(image) {
                if (image) {
                    return `background-image: url(${ image });`;
                }
                return null;
            },
        },
    };
</script>
